import React, { useState } from 'react';
import Button from './common/Button';
import * as Constants from '../constants';
import JOBHACK_LOGO from "../assets/images/logo-jobhack.png";
import LOGO_SO from "../assets/images/logo-scoutout-black.png";

// Menu configuration
const MENU_ITEMS = [
  {
    label: 'หน้าแรก',
    href: 'https://interview.jobhack.co/'
  },
  {
    label: 'บริการสำหรับบริษัท',
    href: 'https://scoutout.co/employer/'
  },
  {
    label: 'บริการสำหรับผู้หางาน',
    href: 'https://scoutout.co/jobseeker/'
  },
  {
    label: 'บทความทั้งหมด',
    href: 'https://blog.scoutout.co/'
  }
];

const PRODUCTS_ITEMS = [
  {
    label: 'HR9',
    href: 'https://scoutout.co/hr9/'
  },
  {
    label: 'JobHack',
    href: 'https://jobhack.co/'
  },
  {
    label: 'JobNOW',
    href: 'https://jobnow.work/'
  },
  {
    label: 'แบบทดสอบบุคลิกภาพ',
    href: 'https://quiz.scoutout.co/home'
  },
  {
    label: 'เช็คเงินเดือน',
    href: 'https://salary.scoutout.co/'
  }
];

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProductsOpen, setIsProductsOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const toggleProducts = () => setIsProductsOpen(!isProductsOpen);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md shadow-md">
      <div className="container mx-auto px-6 py-3">
        {/* Desktop Header */}
        <div className="hidden md:flex justify-between items-center">
          {/* Left: JOBHACK Logo and Powered by */}
          <div className="flex flex-col items-start">
            <img src={JOBHACK_LOGO} alt="JobHack" className="h-8 w-auto mb-1" />
            <div className="flex items-center text-xs text-gray-500">
              <span className="mr-1">Powered by</span>
              <img src={LOGO_SO} alt="ScoutOut" className="h-4 w-auto" />
            </div>
          </div>

          {/* Right: Menu Items */}
          <div className="flex items-center space-x-8">
            {MENU_ITEMS.map((item, index) => (
              <a 
                key={index}
                href={item.href} 
                className="text-gray-700 hover:text-purple-600 transition-colors font-medium"
              >
                {item.label}
              </a>
            ))}
            
            {/* Products Dropdown */}
            <div className="relative group">
              <button 
                className="text-gray-700 hover:text-purple-600 transition-colors font-medium flex items-center"
                onClick={toggleProducts}
              >
                ผลิตภัณฑ์ของเรา
                <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              {/* Dropdown Menu */}
              <div className={`absolute top-full right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 ${isProductsOpen ? 'block' : 'hidden'}`}>
                <div className="py-2">
                  {PRODUCTS_ITEMS.map((item, index) => (
                    <a 
                      key={index}
                      href={item.href} 
                      className="block px-4 py-2 text-gray-700 hover:bg-purple-50 hover:text-purple-600 transition-colors"
                    >
                      {item.label}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Header */}
        <div className="md:hidden flex justify-between items-center">
          {/* Left: JOBHACK Logo and Powered by */}
          <div className="flex flex-col items-start">
            <img src={JOBHACK_LOGO} alt="JobHack" className="h-8 w-auto mb-1" />
            <div className="flex items-center text-xs text-gray-500">
              <span className="mr-1">Powered by</span>
              <img src={LOGO_SO} alt="ScoutOut" className="h-4 w-auto" />
            </div>
          </div>

          {/* Right: Menu Button */}
          <div className="flex items-center">
            <button
              onClick={toggleMenu}
              className="p-2 rounded-md text-gray-700 hover:text-purple-600 hover:bg-purple-50 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`md:hidden ${isMenuOpen ? 'block' : 'hidden'} mt-4 pb-4 border-t border-gray-200`}>
          <div className="pt-4 space-y-2">
            {MENU_ITEMS.map((item, index) => (
              <a 
                key={index}
                href={item.href} 
                className="block px-4 py-2 text-gray-700 hover:bg-purple-50 hover:text-purple-600 transition-colors rounded-md"
              >
                {item.label}
              </a>
            ))}
            
            {/* Mobile Products Section */}
            <div className="px-4 py-2">
              <button 
                onClick={toggleProducts}
                className="flex items-center justify-between w-full text-gray-700 hover:text-purple-600 transition-colors"
              >
                <span>ผลิตภัณฑ์ของเรา</span>
                <svg className={`w-4 h-4 transition-transform ${isProductsOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              <div className={`mt-2 ml-4 space-y-1 ${isProductsOpen ? 'block' : 'hidden'}`}>
                {PRODUCTS_ITEMS.map((item, index) => (
                  <a 
                    key={index}
                    href={item.href} 
                    className="block py-2 text-gray-600 hover:text-purple-600 transition-colors"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
